<div>
  <nz-select
    nzMode="multiple"
    [nzPlaceHolder]="'page.qualifications.partner' | translate"
    [nzMaxTagCount]="1"
    nzAllowClear
    [nzShowArrow]="true"
    (ngModelChange)="saveSelected($event)"
    [ngModel]="selected$ | async"
  >
    @for (item of options$ | async; track item) {
      <nz-option [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
    }
  </nz-select>
</div>
